import { v1 as uuidV1 } from 'uuid';
import { fragmentTypes as introspectionQueryResultData } from 'graphQLSchema';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { ApolloLink, split } from 'apollo-link';
import { getMainDefinition } from 'apollo-utilities';
import { RetryLink } from 'apollo-link-retry';
import appConfig from 'appConfig';
import { getToken } from 'ConnectionManager/sessionManager';
import { logNewrelicAddPageAction } from '../cookies/NewRelic';


const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

const fetchWithSession = (uri, options) => {
  const authToken = getToken();
  // set a custom header (X-Time-Id) for each request that is a time based UUID, used for creating the scope entry;
  const headers = { ...options.headers, Authorization: `Bearer ${authToken}`, 'X-Time-Id': uuidV1() };
  const { operationName } = JSON.parse(options.body);
  return fetch(`${uri}?${operationName}`, { ...options, headers });
};

export default (() => {
  const cache = new InMemoryCache({ fragmentMatcher });

  const retryLink = new RetryLink({
    delay: {
      initial: 5000, // Initial delay between retries in milliseconds
      max: 10000, // Maximum delay between retries in milliseconds
      jitter: true, // Adds randomness to the delays
    },
    attempts: (count, operation, error) => {
      logNewrelicAddPageAction('retrySend', {
        request: operation.variables,
        retryAttempt: count,
        requestType: operation.operationName,
        trigger: JSON.stringify(error, ['message', 'statusCode']),
      });
      return count < 3 && error.statusCode !== 401;
    },
  });

  const httpLink = new HttpLink({
    uri: appConfig.getLearnerGraphqlEndpoint(),
    fetch: fetchWithSession,
  });

  const splitLink = split(
    // Split based on operation type
    ({ query }) => {
      const { kind, operation } = getMainDefinition(query);
      return kind === 'OperationDefinition' && operation === 'query';
    },
    retryLink.concat(httpLink), // RetryLink for queries only
    httpLink // HttpLink for mutations and subscriptions
  );


  return new ApolloClient({
    cache,
    link: ApolloLink.from([splitLink]),
  });
})();
